import {
  defineNuxtPlugin, injectHead, useRuntimeConfig
} from '#imports'

// Widget build only (`--envName widget`): the app lives inside someone else's page.
export default defineNuxtPlugin({
  name: 'widget',
  setup (nuxtApp) {
    if (!useRuntimeConfig().public.WIDGET) return

    // The host page embeds <vc-widget widget="…">; Nuxt mounts on `#vc-widget` (app.rootId), and plugins run before mount
    document.querySelector('vc-widget')?.setAttribute('id', 'vc-widget')

    // never write title/meta/canonical/hreflang/json-ld/lang into the host page's <head>
    injectHead().hooks.hook('dom:beforeRender', ctx => { ctx.shouldRender = false })

    // no Lenis here (<the-scroll> lives in the default layout): native scroll, 'top' = top of the widget
    nuxtApp.bus.on('scroll:scroll-to', ({ target }) => {
      const el = target === 'top' || target === 0
        ? document.querySelector('vc-widget')
        : typeof target === 'string' ? document.querySelector(target) : target

      el?.scrollIntoView?.({ behavior: 'smooth' })
    })
  }
})
